"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePicker = void 0;
_Object$defineProperty(exports, "DayPickerRangeController", {
  enumerable: true,
  get: function () {
    return _reactDates.DayPickerRangeController;
  }
});
exports.SingleDatePickerDropdown = exports.SingleDatePicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
require("react-dates/initialize");
var _KyruusTheme = _interopRequireWildcard(require("./KyruusTheme"));
require("react-dates/lib/css/_datepicker.css");
var _reactDates = require("react-dates");
var _ArrowDown = _interopRequireDefault(require("@kyruus/react-ikons/ArrowDown"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SingleDatePicker = props => /*#__PURE__*/_react.default.createElement(_KyruusTheme.default, null, /*#__PURE__*/_react.default.createElement(_reactDates.SingleDatePicker, props));
exports.SingleDatePicker = SingleDatePicker;
const DateRangePicker = props => /*#__PURE__*/_react.default.createElement(_KyruusTheme.default, null, /*#__PURE__*/_react.default.createElement(_reactDates.DateRangePicker, props));
exports.DateRangePicker = DateRangePicker;
const SingleDatePickerDropdown = _ref => {
  let {
    label,
    width,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_KyruusTheme.StyledSingleDatePicker, {
    width: width
  }, /*#__PURE__*/_react.default.createElement(_KyruusTheme.StyledLabel, {
    htmlFor: "custom-date-picker"
  }, label), /*#__PURE__*/_react.default.createElement(_reactDates.SingleDatePicker, (0, _extends2.default)({}, props, {
    inputIconPosition: "after",
    customInputIcon: /*#__PURE__*/_react.default.createElement(_ArrowDown.default, null),
    displayFormat: "MM/DD/YYYY",
    id: "custom-date-picker"
  })));
};
exports.SingleDatePickerDropdown = SingleDatePickerDropdown;
SingleDatePickerDropdown.propTypes = {
  label: _propTypes.default.string.isRequired,
  width: _propTypes.default.string
};

// NOTE:
// These have not been tested or themed.
// Are being exposed here for reference until they're needed
SingleDatePicker.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleDatePicker"
};
DateRangePicker.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DateRangePicker"
};
SingleDatePickerDropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleDatePickerDropdown",
  "props": {
    "label": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "width": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};